import useSWR from 'swr';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigationStore } from '@/store/useNavigationStore';
import { fetchExpoStructure } from '@/api/expoStructure';

/**
 * Fetches the exposition navigation structure from Dédalo and writes it to the store.
 * Call this once at the app's language gate (LangGuard) — never inside individual pages.
 * SWR caches per language, so switching languages re-fetches once and then hits the cache.
 */
export function useExpoStructure() {
    const { i18n } = useTranslation();
    const setNavigationData = useNavigationStore((s) => s.setNavigationData);

    const { data, isLoading, error } = useSWR(
        ['expoStructure', i18n.language],
        ([, lang]) => fetchExpoStructure(lang),
        { revalidateOnFocus: false }
    );

    useEffect(() => {
        if (data) {
            setNavigationData({
                expoTitle: data.expoTitle,
                pages: data.pages ?? [],
                pageGroups: data.pageGroups ?? [],
                mymLinks: data.mymLinks ?? [],
                report: data.report ?? null,
            });
        }
    }, [data, setNavigationData]);

    return { isLoading, error };
}
